module.exports = "/static/assets/36b78bbefbadfa3a0557ec22c3fed5a6.png";